import React from 'react';
import { formatReportNumberFa, formatReportMoneyFa } from './chartFormatters';

/** گزارش مالی — خط مبلغ */
export function FinanceLineTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const amount = payload[0]?.value;
  return (
    <div
      className="rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 shadow-md dark:border-slate-600 dark:bg-slate-800 text-sm custom-font"
      dir="rtl"
    >
      <p className="m-0 mb-1 text-xs text-slate-500 dark:text-slate-400">تاریخ</p>
      <p className="m-0 mb-2 font-medium text-slate-800 dark:text-slate-100">{label}</p>
      <p className="m-0 text-slate-700 dark:text-slate-200">
        <span className="text-slate-500">مبلغ: </span>
        <span className="font-medium tabular-nums">{formatReportMoneyFa(amount)}</span>
      </p>
    </div>
  );
}

/** درآمد / هزینه */
export function IncomeExpenseTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const labelMap = {
    درآمد: 'درآمد',
    هزینه: 'هزینه',
    income: 'درآمد',
    expense: 'هزینه',
  };
  return (
    <div
      className="rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 shadow-md dark:border-slate-600 dark:bg-slate-800 text-sm custom-font"
      dir="rtl"
    >
      <p className="m-0 mb-2 font-medium text-slate-800 dark:text-slate-100">{label}</p>
      {payload.map((p) => {
        const title = labelMap[p.name] || labelMap[p.dataKey] || p.name || 'مقدار';
        return (
          <p key={String(p.dataKey)} className="m-0 my-1 flex justify-between gap-4 text-slate-700 dark:text-slate-200">
            <span style={{ color: p.color }}>{title}</span>
            <span className="tabular-nums font-medium">{formatReportMoneyFa(p.value)}</span>
          </p>
        );
      })}
    </div>
  );
}

/** میله‌ای ساده (مبلغ) */
export function AmountBarTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const v = payload[0]?.value;
  return (
    <div
      className="rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 shadow-md dark:border-slate-600 dark:bg-slate-800 text-sm custom-font"
      dir="rtl"
    >
      <p className="m-0 mb-1 text-xs text-slate-500">برچسب</p>
      <p className="m-0 mb-2 font-medium text-slate-800 dark:text-slate-100">{label}</p>
      <p className="m-0 text-slate-700">
        <span className="text-slate-500">مبلغ: </span>
        <span className="tabular-nums font-medium">{formatReportMoneyFa(v)}</span>
      </p>
    </div>
  );
}

/** دایره‌ای دسته‌بندی */
export function PieCategoryTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const p = payload[0];
  const name = p?.name ?? p?.payload?.label ?? '';
  const value = p?.value;
  return (
    <div
      className="rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 shadow-md dark:border-slate-600 dark:bg-slate-800 text-sm custom-font"
      dir="rtl"
    >
      <p className="m-0 mb-1 text-xs text-slate-500">دسته</p>
      <p className="m-0 mb-2 font-medium text-slate-800 dark:text-slate-100">{name}</p>
      <p className="m-0">
        <span className="text-slate-500">مبلغ: </span>
        <span className="tabular-nums font-medium">{formatReportMoneyFa(value)}</span>
      </p>
    </div>
  );
}

/** معاملات / تعداد */
export function CountBarTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const v = payload[0]?.value;
  return (
    <div
      className="rounded-lg border border-slate-200/90 bg-white px-3 py-2.5 shadow-md dark:border-slate-600 dark:bg-slate-800 text-sm custom-font"
      dir="rtl"
    >
      <p className="m-0 mb-1 text-xs text-slate-500">مرحله</p>
      <p className="m-0 mb-2 font-medium text-slate-800 dark:text-slate-100">{label}</p>
      <p className="m-0 text-slate-700">
        <span className="text-slate-500">تعداد: </span>
        <span className="tabular-nums font-medium">{formatReportNumberFa(v)}</span>
      </p>
    </div>
  );
}
